<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Services
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Helpers
	import { real_id } from 'src/helpers/interface_helpers';
	import { capFirstChar } from 'src/helpers/utilities';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	//Stores
	import { devices_settings } from 'src/stores/device-runtime/status';
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Toggle } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from 'src/types/Device';
	import type { SettingRequest } from 'src/types/requests/settings/setting';

	export let device: Device;

	const deviceID = real_id(device.id);
	const component = `input:${device.channel}`;
	const settings = readDeviceSettings(device.id);

	let checked = settings[component].enable;
	let waitingRorRequest = false;

	const sentRequests = async () => {
		checked = !checked;
		if (waitingRorRequest || checked == settings[component].enable) return;
		waitingRorRequest = true;
		const enable = checked;
		const res: SettingRequest = await gen2Request(device, 'Input.SetConfig', {
			id: device.channel,
			config: { enable },
		});
		if (res.isok) {
			settings[component].enable = checked = enable;
			devices_settings.update_devices_settings(deviceID, settings);
		} else {
			checked = settings[component].enable;
		}
		onSettingsResponse(res, device);
		waitingRorRequest = false;
	};
</script>

<Toggle {checked} size="m" on:click={sentRequests} id="toggle-bxc3eqh">
	{capFirstChar(
		$format('enable', {
			default: 'Enable',
		}),
	)}
</Toggle>
